import React, { createContext, useContext, useState } from "react";

// Shares "is the current job a Japan job?" between JobLanguageSync (which fetches
// the job's content_language) and the LanguageSwitcher (which only renders for
// Japan jobs). Non-Japan jobs are always English with no switcher.
const JobLangContext = createContext({ isJapanJob: false, setIsJapanJob: () => {} });

export function JobLangProvider({ children }) {
    const [isJapanJob, setIsJapanJob] = useState(false);
    return (
        <JobLangContext.Provider value={{ isJapanJob, setIsJapanJob }}>
            {children}
        </JobLangContext.Provider>
    );
}

export const useJobLang = () => useContext(JobLangContext);

export default JobLangContext;
